module.exports = __webpack_public_path__ + "img/initial1975.b6e1d84a.png";